import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiDialogTitle from '@mui/material/DialogTitle';
import { Icon } from '@famly/mf_data-display_icon';
import { getEmphasizedFontWeight } from '@famly/mf_theme';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
/**
 * Correctly styled modal title container including an optional id,
 * which should be used for aria purpose
 *
 * @param title title of the modal to be rendered
 * @param id optional id, which should be provided for testing and accessibility
 */
export const ModalTitle = ({ title, id, icon }) => {
    const { isMobileLandscapeAndLarger } = useBreakpoints();
    return (_jsxs(MuiDialogTitle, { id: id, component: "h6", sx: theme => ({
            padding: '0px',
            color: theme.modernFamlyTheme.colorPalette.n400,
            fontWeight: getEmphasizedFontWeight('h6'),
            // ellipsis
            width: { base: '80%', mobileLandscape: '85%' },
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: isMobileLandscapeAndLarger ? 1 : 2,
        }), children: [icon ? _jsx(Icon, { name: icon }) : null, title] }));
};
